// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__YsPOb","calendarButtons":"ClockData_calendarButtons__3n3Dx"};